import React from 'react';
import { Link } from "react-router-dom";

class Solvencias extends React.Component {

    render() {

        return (
            <div className="container mt-4">

                <div className="card shadow">

                    <div className="card-header bg-dark text-white">
                        <h4>MÓDULO DE SOLVENCIAS</h4>
                    </div>

                    <div className="card-body">

                        <div className="row">

                            <div className="col-md-4 mb-3">
                                <Link
                                    to="/crearsolvencias"
                                    className="btn btn-success w-100 p-4"
                                >
                                    <i className="bi bi-receipt-cutoff me-2"></i>
                                    + NUEVA SOLVENCIA
                                </Link>
                            </div>

                            <div className="col-md-4 mb-3">
                                <Link
                                    to="/listarsolvencias"
                                    className="btn btn-primary w-100 p-4"
                                >
                                    <i className="bi bi-search me-2"></i>
                                    CONSULTAR SOLVENCIAS
                                </Link>
                            </div>


                            <div className="col-md-4 mb-3">
    <Link
        to="/reportessolvencias"
        className="btn btn-danger w-100 p-4"
    >
        <i className="bi bi-file-earmark-pdf me-2"></i>
        REPORTES
    </Link>
</div>

                        </div>

                    </div>

                </div>

            </div>
        )
    }
}

export default Solvencias;